import type { AxiosInstance } from 'axios'

import type { EntityMappingPayload } from '../models/entityMapping.types'

import { DEFINITIONS_REQUEST_CONFIG } from './config'

import { ApiError, appHttp, unwrap } from '@/shared/http'

export type EntityMappingError = ApiError

export function normalizeEntityMappingError(cause: unknown): EntityMappingError {
  return ApiError.isApiError(cause) ? cause : ApiError.fromAxios(cause)
}

export class EntityMappingApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  async get(
    path: string,
    scheduleId: number | string,
    signal?: AbortSignal,
  ): Promise<Record<string, unknown>> {
    return (
      unwrap(
        await this.http.get<Record<string, unknown>>(`${path}?schedule_id=${scheduleId}`, {
          ...DEFINITIONS_REQUEST_CONFIG,
          ...(signal ? { signal } : {}),
        }),
      ) ?? {}
    )
  }

  async save(path: string, payload: EntityMappingPayload): Promise<unknown> {
    return unwrap(await this.http.post(path, payload, DEFINITIONS_REQUEST_CONFIG))
  }

  /** `/adgroup-mapping/{w}/bq` deliberately has no trailing slash. */
  static adGroupBqPath(workspaceId: number | string): string {
    return `/adgroup-mapping/${workspaceId}/bq`
  }
}

export const entityMappingApi = new EntityMappingApi()
